import { render, staticRenderFns } from "./limit-list.vue?vue&type=template&id=b608d4fc"
import script from "./limit-list.vue?vue&type=script&lang=js"
export * from "./limit-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports